import React from 'react';
import { Layout, routes, siteName, pageTypes, AdMobileAnchor, AdMobileBanner, AdLeaderboard } from 'gatsby-theme-apollo';
import Footer from './footer';
import GameContent from './content';
import MarkDownContent from '../posts/markdown-content';
import Section from '../layout/section';
import Recommendations from '../entities/recommendations';
import { ContentBox } from '../layout/content-box';

const GameMode = ({ location, pageContext }) => {
  const pageType = pageTypes.GAME_MODE;
  const { gameName, mode, EntityConfigs } = pageContext;
  const { name, description, recommendations } = mode;

  const pageTitle = `${name} | ${gameName} | ${siteName}`;

  const crumbs = [{ text: gameName, url: routes.TierListHub(gameName) }];

  return (
    <Layout location={location} gameName={gameName} title={pageTitle} pageType={pageType}>
      <AdMobileAnchor placementId={'gh-anchor-' + pageType +'-bottom'} anchorType='bottom' offset='47' />
      <GameContent header={`${name}`} headerTextSize={`32px`} pop crumbs={crumbs}>
        <AdMobileBanner placementId={"gh-mobilebanner-" + pageType + "-top"} />
        <AdLeaderboard placementId={"gh-leaderboard-" + pageType + "-top"} />
        
        <Section solidBackground>
          <ContentBox>
            <MarkDownContent md={description} />
          </ContentBox>
        </Section>

        <Section title="Recommendations" solidBackground>
          <ContentBox>
            <Recommendations
              gameName={gameName}
              recommendations={recommendations}
              EntityConfigs={EntityConfigs}
            />
          </ContentBox>
        </Section>
      </GameContent>
      <Footer />
    </Layout>
  );
};

export default GameMode;
